import { IDriverDeviceInputDto } from './device-input-dto.interface';
import { ITachographInputDto } from './tachograph-input-dto.interface';
import { ExternalDriverAllowedActions } from '../enums';

export interface ICreateDriverDto {
    organizationId?: string;
    name: string;
    surname: string;
    externalId?: string;
    inDuty?: boolean;
    nationalId?: string;
    carrierId: string;
    code?: string;
    licenseNumber?: string;
    phoneNumber: string;
    status?: string;
    assignedVehicle?: string;
    tags?: string[];
    photo?: string;
    externalOrganizations?: IDriverExternalOrganizationsInputDto[];
}

export interface IDriverExternalOrganizationsInputDto {
    organizationId: string;
    allowedActions?: ExternalDriverAllowedActions[];
}

export interface IUpdateDriverDto extends Partial<ICreateDriverDto> {
    invitationLink?: string;
    tachograph?: ITachographInputDto;
    device?: IDriverDeviceInputDto;
    wasInvited?: boolean;
    blocked?: boolean;
}
